import { render } from "./i-disclaimer.vue?vue&type=template&id=21790e43&scoped=true"
import script from "./i-disclaimer.vue?vue&type=script&lang=js"
export * from "./i-disclaimer.vue?vue&type=script&lang=js"

import "./i-disclaimer.vue?vue&type=style&index=0&id=21790e43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21790e43"]])

export default __exports__